import * as React from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/export_plan_annotations_wizard/ExportPlanAnnotationsWizard.scss';
import Button from '../../components/Button';
import { __ } from '../../core/utils';
import * as _ from 'lodash';
import Checkbox from '../../components/Checkbox';
import { connect } from 'react-redux';

const ExportPlanAnnotationsForm = ({
  handleSubmit,
  submitting,
  actions: { hideExportPlanAnnotationsWizard },
  values,
}) => {
  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.flex}>
        <div className={styles.f1}>
          <div className={styles.title}>
            {__('plans.export.title.select-elements')}
          </div>
          <div className={styles.options}>
            <Field
              name='annotations'
              component={Checkbox}
              label={__('plans.export.annotations')}
            />

            {values.annotations == true && (
              <div className={styles.suboptions}>
                <Field
                  name='lines'
                  component={Checkbox}
                  label={__('plans.export.lines')}
                />
                <Field
                  name='ellipses'
                  component={Checkbox}
                  label={__('plans.export.ellipses')}
                />
                <Field
                  name='rectangles'
                  component={Checkbox}
                  label={__('plans.export.rectangles')}
                />
                <Field
                  name='polygons'
                  component={Checkbox}
                  label={__('plans.export.polygons')}
                />
                <Field
                  name='freehands'
                  component={Checkbox}
                  label={__('plans.export.freehands')}
                />
                <Field
                  name='clouds'
                  component={Checkbox}
                  label={__('plans.export.clouds')}
                />
                <Field
                  name='tasks'
                  component={Checkbox}
                  label={__('plans.export.tasks')}
                />
                <Field
                  name='specifications'
                  component={Checkbox}
                  label={__('plans.export.specifications')}
                />
                <Field
                  name='plans'
                  component={Checkbox}
                  label={__('plans.export.plans')}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('plans.export.button.cancel')}
          onClick={hideExportPlanAnnotationsWizard}
        />
        <Button
          lightBlue
          medium
          submit
          right
          middleText={__('plans.export.button.export')}
          spinning={submitting}
        />
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    values: getFormValues(
      'export_plan_annotations_wizard.export_plan_annotations'
    )(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      hideExportPlanAnnotationsWizard: () => {
        dispatch({
          type: 'table.working_set_plans/SET_TABLE_PARAMS',
          params: {
            export_plan_annotations_wizard: undefined,
          },
        });

        dispatch({
          type: 'table.current_set_plans/SET_TABLE_PARAMS',
          params: {
            export_plan_annotations_wizard: undefined,
          },
        });
      },
    },
  };
};

export default reduxForm({
  form: 'export_plan_annotations_wizard.export_plan_annotations',
})(connect(mapStateToProps, mapDispatchToProps)(ExportPlanAnnotationsForm));
